export var ProgressStatus;
(function (ProgressStatus) {
    ProgressStatus[ProgressStatus["PreRun"] = 0] = "PreRun";
    ProgressStatus[ProgressStatus["Current"] = 1] = "Current";
    ProgressStatus[ProgressStatus["Resulting"] = 2] = "Resulting";
    ProgressStatus[ProgressStatus["PostRun"] = 3] = "PostRun";
})(ProgressStatus || (ProgressStatus = {}));
var PeriodProgressState = /** @class */ (function () {
    function PeriodProgressState(source) {
        this.progressStatus = source.progressStatus;
        this.periodRelativeProgressInMilli = source.periodRelativeProgressInMilli;
        this.relativePercentProgress = source.relativePercentProgress;
    }
    return PeriodProgressState;
}());
export { PeriodProgressState };
//# sourceMappingURL=PeriodProgressState.js.map